import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  footerRoot: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
  footerWrapper: {
    display: 'flex',
    gap: theme.spacing(3),
    marginRight: theme.spacing(8),
  },
  heading: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.25px',
  },
}))
